import {
  BaseEdge,
  getBezierPath,
  type EdgeProps,
  EdgeLabelRenderer,
} from '@xyflow/react'

export function ConditionalEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  })

  const isConditional = data?.condition != null

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: isConditional
            ? 'hsl(var(--primary))'
            : 'hsl(var(--border))',
          strokeWidth: isConditional ? 2 : 1,
          strokeDasharray: isConditional ? '5 5' : 'none',
        }}
        className={selected ? 'opacity-100' : ''}
      />
      {isConditional && data?.branch_label && (
        <EdgeLabelRenderer>
          <div
            className="absolute bg-secondary border border-border rounded-full px-2 py-0.5 text-xs font-semibold text-foreground pointer-events-all"
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            }}
          >
            {String(data.branch_label)}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
}
